import type { Practice, Section } from '../api/types';
import { Reveal } from './Reveal';
import styles from './Practices.module.css';

interface PracticesProps {
  section: Section;
  practices: Practice[];
}

export function Practices({ section, practices }: PracticesProps) {
  return (
    <section className="section" id="services">
      <div className="shell">
        <Reveal className="sectionHead">
          <p className="eyebrow">{section.eyebrow}</p>
          <h2>{section.title}</h2>
          {section.body ? <p className="lead">{section.body}</p> : null}
        </Reveal>

        <Reveal className={styles.grid}>
          {practices.map((practice) => (
            <article key={practice.id} className={styles.card} id={practice.id}>
              <span className={styles.tag}>{practice.tag}</span>
              <h3>{practice.title}</h3>
              <p className={styles.body}>{practice.body}</p>
              <ul className={styles.tools}>
                {practice.tools.map((tool) => (
                  <li key={tool}>{tool}</li>
                ))}
              </ul>
            </article>
          ))}
        </Reveal>
      </div>
    </section>
  );
}
